
 import { Component, OnInit, Input, Output, EventEmitter, OnChanges, SimpleChanges, OnDestroy } from '@angular/core';

 import { ColumnModel, ColumnTypes } from '../model/column-model';
 import { MxBaseRestService } from 'mx-commons';
 import { isNullOrUndefined } from 'util';
 import { trigger, state, style, transition, animate } from '@angular/animations';
 import { debounceTime } from 'rxjs/operators';
 
 
 @Component({
   selector: 'data-table-list',
   templateUrl: './data-table-list.component.html',
   styleUrls: ['./data-table-list.component.scss'],
   animations: [
     trigger('fade', [
       state('void', style({ opacity: 0 })),
       transition('void => *', [
         style({ opacity: 0 }),
         animate('300ms', style({ opacity: 1 }))
       ]),
       transition('* => void', [
         style({ opacity: 1 }),
         animate('100ms', style({ opacity: 0 }))
       ])
     ])
   ]
 })
 export class DataTableListComponent implements OnInit, OnDestroy, OnChanges {
  @Input()
  private mxEntidade: string;
  @Input()
  private mxGetList = '';
  @Input()
  public mxColumns: ColumnModel[];
  @Input()
  public mxPageSize = 15;
  @Input()
  public mxOrderBy?: ColumnModel;
  @Input()
  public mxActionsEnable: Array<ActionDataList> = [ActionDataList.NEW, ActionDataList.SELECT];
  @Input()
  private mxRequestFiltersMongoDb = false;
  @Input()
  public mxIconAdiction = 'fa-edit';
  @Input()
  public mxShowPrinter: boolean = false;
 
   @Output() mxOnSelect = new EventEmitter<any>();
   @Output() mxOnNew = new EventEmitter<any>();
   @Output() mxOnAdiction = new EventEmitter<any>();
   @Output() mxReturnRegisters = new EventEmitter<any>();
 
   ColumnTypes = ColumnTypes;
   ActionDataList = ActionDataList;
 
   isLoading = true;
   showLoading = true;
   onLoadRequest: EventEmitter<void> = new EventEmitter<void>();
 
   // pageSize = 15;
   filtros = [];
   registros = [];
   pagSelect = 1;

   total: number;
  //  totPag = 0;
	complexTypeFilter ={};
   operacoes = [{
     value: 'like',
     descricao: 'Contém',
     types: [ColumnTypes.STRING]
   }, {
     value: '=',
     descricao: 'Igual',
     types: [ColumnTypes.STRING, ColumnTypes.INTEGER, ColumnTypes.DOUBLE, ColumnTypes.CURRENCY,
     ColumnTypes.DATE, ColumnTypes.DATETIME, ColumnTypes.BOOLEAN, ColumnTypes.CUSTOM, ColumnTypes.ENUM,ColumnTypes.COMPLEX]
   }, {
     value: '!=',
     descricao: 'Diferente',
     types: [ColumnTypes.STRING, ColumnTypes.INTEGER, ColumnTypes.DOUBLE, ColumnTypes.CURRENCY,
     ColumnTypes.DATE, ColumnTypes.DATETIME]
   }, {
     value: 'likeInit',
     descricao: 'Inicia',
     types: [ColumnTypes.STRING]
   }, {
     value: 'likeEnd',
     descricao: 'Termina',
     types: [ColumnTypes.STRING]
   }, {
     value: '>',
     descricao: 'Maior',
     types: [ColumnTypes.INTEGER, ColumnTypes.DOUBLE, ColumnTypes.CURRENCY, ColumnTypes.DATE, ColumnTypes.DATETIME]
   }, {
     value: '>=',
     descricao: 'Maior Igual',
     types: [ColumnTypes.INTEGER, ColumnTypes.DOUBLE, ColumnTypes.CURRENCY, ColumnTypes.DATE, ColumnTypes.DATETIME]
   }, {
     value: '<',
     descricao: 'Menor',
     types: [ColumnTypes.INTEGER, ColumnTypes.DOUBLE, ColumnTypes.CURRENCY, ColumnTypes.DATE, ColumnTypes.DATETIME]
   }, {
     value: '<=',
     descricao: 'Menor igual',
     types: [ColumnTypes.INTEGER, ColumnTypes.DOUBLE, ColumnTypes.CURRENCY, ColumnTypes.DATE, ColumnTypes.DATETIME]
   }];
 
   private typesCenter = [ColumnTypes.DATE, ColumnTypes.DATETIME, ColumnTypes.INTEGER, ColumnTypes.BOOLEAN];
   private typesRight = [ColumnTypes.CURRENCY, ColumnTypes.DOUBLE];
 
   constructor(private readonly restService: MxBaseRestService) {
     this.onLoadRequest.pipe(debounceTime(500)).subscribe(() => {
       if (this.isLoading) {
         this.showLoading = true;
       }
     });
   }
 
   ngOnInit() {
    //console.log("Columns->",this.mxColumns);
     if ((this.filtros || []).length === 0) {
       this.initialize();
     }
   }
 
   ngOnDestroy() {
     this.filtros = null;
     this.registros = [];
   }
 
   ngOnChanges(changes: SimpleChanges) {
     if (changes.mxEntidade) {
       this.reloadAll();
     }
   }
 
   public reloadAll(): void {
     this.showLoading = true;
     this.initialize();
   }
 
   private initialize() {
    // this.findTotal()

     this.filtros = null;
     this.registros = [];
     this.addFiltro();
     this.filterRequest();
   }
 
   go(page) {
     this.pagSelect = page;
     this.filterRequest();
   }
 
   selectOrderBy(collumn) {
     if (this.mxOrderBy === collumn) {
       this.mxOrderBy.orderDir = (this.mxOrderBy.orderDir === '1' ? '-1' : '1');
     } else {
       this.mxOrderBy = collumn;
       this.mxOrderBy.orderDir = '1';
     }
     this.filter();
   }
   
   //cria um filtro a partir do primeiro elemento vindo de mxColumns
   addFiltro() {
     if (!this.filtros) {
       this.filtros = [];
     }
     const f: any = {};
     f.operacao = this.operacoes[this.mxColumns[0].type === ColumnTypes.STRING ? 0 : 1];
     if (isNullOrUndefined(this.mxOrderBy)) {
       this.mxOrderBy = this.mxColumns[0];
     }
     f.collumn = this.mxColumns[0];
     f.value = '';
     this.filtros.push(f);
   }
 
   changeCampo(index) {
     this.filtros[index].operacao = {};
     for (const operacao of this.operacoes) {
       if (operacao.types.indexOf(this.filtros[index].collumn.type) > -1) {
         this.filtros[index].operacao = operacao;
         break;
       }
     }
   }
 
   delFiltro(index) {
     this.filtros.splice(index, 1);
   }
 
   filter() {
    this.pagSelect = 1;
    this.filterRequest();
   }

   findTotal() {
    this.restService.totalEntity(this.mxEntidade).subscribe((data: any) => {
      this.total = data
    })
   }
 
   filterRequest() {
     this.isLoading = true;
     this.onLoadRequest.emit();
     try {
       let first = 0;
       if (this.pagSelect > 1) {
         first = ((this.pagSelect * this.mxPageSize) - this.mxPageSize);
       }
       const filter = `?offset=${first}&limit=${this.mxPageSize}&sort=${this.mxOrderBy.name}:${Number(this.mxOrderBy.orderDir)}`;
       const filters = this.mountFilters();
       let headers = null;
       if (filters.length > 0) {
         if (this.mxRequestFiltersMongoDb) {
           headers = { filter: JSON.stringify({ $and: filters }) };
         } else {
           headers = { filter: JSON.stringify(filters) };
         }
       }
 
       this.restService.listAll(this.mxEntidade + (this.mxGetList || ''), filter, headers).subscribe((data: any) => {
         this.total = data.total
         this.registros = (data && data.docs ? data.docs : []);
         this.createArrayForComplexTypeFilter(data && data.docs ? data.docs : []);
         if (data.docs.length === 0 && data.total > 0) {
           this.pagSelect = 1;
           this.filterRequest();
           return;
         }
       }, () => {
         // error
       }, () => {
         this.isLoading = false;
         this.showLoading = false;
       });
     } catch (error) {
       this.isLoading = false;
       this.showLoading = false;
     }
   }
 
   private mountFilters(): Array<any> {
    const filters: Array<any> = new Array<any>();
    
    for (const f of this.filtros) {
      let filtroStr = null;
      if (f.collumn.type === ColumnTypes.ENUM) {
        if(f.filtro > -1) {
          filtroStr = f.filtro;
        }
      } else if ((f.filtro || '').toString().trim().length > 0 || f.filtro === true || f.filtro === false) {
        if ([ColumnTypes.DATE, ColumnTypes.DATETIME].indexOf(f.collumn.type) > -1 && this.isDate(f.filtro)) {
          f.filtro.setHours(0, 0, 0);
          filtroStr = this.mxRequestFiltersMongoDb ? `ISODate("${f.filtro.toISOString()}")` : f.filtro.getTime();
        } else if ([ColumnTypes.INTEGER, ColumnTypes.CURRENCY].indexOf(f.collumn.type) > -1) {
          filtroStr = Number(f.filtro);
        } else if (f.collumn.type === ColumnTypes.BOOLEAN) {
          filtroStr = Boolean(f.filtro);
        } else if (ColumnTypes.DOUBLE === f.collumn.type) {
          filtroStr = f.filtro
        } else {
          filtroStr = (f.filtro || '').trim();
        }
      }
 
       
       if (!isNullOrUndefined(filtroStr)) {
         let filter;
         if (this.mxRequestFiltersMongoDb) {
           const c = f.collumn.name;
           const operacao = f.operacao;
           filter = JSON.parse(`{ "${c}": null }`);
           if (operacao.value === '=') {
             filter[c] = filtroStr;
           } else if (operacao.value === '!=') {
             filter[c] = { $ne: filtroStr };
           } else if (operacao.value === 'like') {
              filter[c] = { $regex: `.*${filtroStr}.*`, $options: 'i' };
           } else if (operacao.value === 'likeInit') {
             filter[c] = { $regex: `${filtroStr}.*`, $options: 'i' };
           } else if (operacao.value === 'likeEnd') {
             filter[c] = { $regex: `.*${filtroStr}`, $options: 'i' };
           } else if (operacao.value === '>') {
             filter[c] = { $gt: filtroStr };
           } else if (operacao.value === '>=') {
             filter[c] = { $gte: filtroStr };
           } else if (operacao.value === '<') {
             filter[c] = { $lt: filtroStr };
           } else if (operacao.value === '<=') {
             filter[c] = { $lte: filtroStr };
           }
         } else {
          if(f.collumn.type !== ColumnTypes.COMPLEX){
            filter = {
              column: f.collumn.name,
              operation: f.operacao.value,
              value: filtroStr
            };
          }else{
            filter = {
              column:f.collumn.name,
              operation: "complex",
              value: f.filtro,
            };
          }
         }
         filters.push(filter);
       }
     }
     
     return filters;
   }
 
   onSelect(registro) {
    console.log("Fui clicado",registro);
     this.mxOnSelect.emit(registro);
   }
 
   onNew() {
     this.mxOnNew.emit();
   }
 
   onAdiction(registro) {
     this.mxOnAdiction.emit(registro);
   }

   onPrintReport(registros){
    const filters = this.mountFilters();
    let headers = null;
    const filter = `?offset=0&limit=999999&sort=${this.mxOrderBy.name}:${Number(this.mxOrderBy.orderDir)}`;

    if (filters.length > 0) {
      if (this.mxRequestFiltersMongoDb) {
        headers = { filter: JSON.stringify({ $and: filters }) };
      } else {
        headers = { filter: JSON.stringify(filters) };
      }
    }

    this.restService.listAll(this.mxEntidade + (this.mxGetList || ''), filter, headers).subscribe((data) => {
      this.mxReturnRegisters.emit(data.docs)
    })
   }

   onPrint(){
    var printContents = document.getElementById('print-area').innerHTML;
    var originalContents = document.body.innerHTML;
    document.body.innerHTML = printContents;
    window.print();
    document.body.innerHTML = originalContents;
   }
 
   isBoolean(val) {
     return (typeof val === 'boolean') && !this.isDate(val);
   }
 
   isString(val) {
     return (typeof val === 'string') && !this.isDate(val);
   }
 
   isNumber(val) {
     return (typeof val === 'number') && !this.isDate(val);
   }
 
   isDate(val) {
     const da = Date.parse(val);
     return (da && (new Date(da) || Date.parse(da.toString())));
   }
 
   isDefined(value: any): boolean {
     return !isNullOrUndefined(value);
   }
 
   getColumnTextAlign(c: any) {
     let align = null;
     if (c.style) {
       if (c.style.indexOf('center') > -1) {
         align = 'center';
       } else if (c.style.indexOf('right') > -1) {
         align = 'right';
       } else if (c.style.indexOf('left') > -1) {
         align = 'left';
       }
     }
     return align || (this.typesCenter.indexOf(c.type) > -1 ? 'center' : this.typesRight.indexOf(c.type) > -1 ? 'right' : 'left');
   }

   getDisplay(c:ColumnModel){
    let display= null;
    if (c.style) {
      if (c.style.indexOf('none') > -1) {
        display = 'none';
      }
    }
    return display
   }
 
   getColumnWidth(c: ColumnModel) {
     let width = null;
     if (c.style) {
       width = c.style.find(s => s.indexOf('%') > -1);
     }
     return width || 'fit-content';
   }
 
   getOperacoes(filtro) {
     return this.operacoes.filter(o => o.types.indexOf(filtro.collumn.type) > -1);
   }
 
   isOnNew(): boolean {
     return this.mxOnNew.observers.length > 0 && (this.mxActionsEnable || []).indexOf(ActionDataList.NEW) > -1;
   }
 
   isOnAdiction(): boolean {
     return this.mxOnAdiction.observers.length > 0 && (this.mxActionsEnable || []).indexOf(ActionDataList.ADICTION) > -1;
   }
 
   isOnSelect(): boolean {
     return this.mxOnSelect.observers.length > 0 && (this.mxActionsEnable || []).indexOf(ActionDataList.SELECT) > -1;
   }
 
   getBooleanString(value: any): string {
     return (value !== null ? value ? 'Sim' : 'Não' : '');
   }
 
   resolve(path: string, obj: object): any {
     if (path.indexOf('.') > -1) {
       return path.split('.').reduce((prev: object, curr: string) => (prev && prev.hasOwnProperty(curr)) ? prev[curr] : '', obj);
     } else {
       return obj[path];
     }
   }

   resolveComplex(obj:any,columnName:string){
    return obj[columnName].length.toString()
   }
 
   mxNotifyItemChange(data: any, checkRegistro: (registro: any) => boolean): void {
     const idxOld = this.registros.findIndex(value => checkRegistro(value));
     if (idxOld > -1) {
       this.registros.splice(idxOld, 1, data);
     } else {
       this.registros.splice(idxOld, 0, data);
     }
   }
 
   mxNotifyItemDelete(checkRegistro: (registro: any) => boolean): void {
     const idxOld = this.registros.findIndex(value => checkRegistro(value));
     if (idxOld > -1) {
       this.registros.splice(idxOld, 1);
     }
   }

  // cria uma atributo no obj complextTypeFilter para cada tipo de mxColumn do tipo COMPLEX
  createArrayForComplexTypeFilter(responseArray:any[]){
    //gruarda o nome da coluna que é igual ao nome do atributo que vem da request
    let complexColumnNames = [];
    let searchIntoComplexDataBy =[];
    //verifica quais atributos das colunas é do tipo COMPLEX
    for(let column of this.mxColumns){
      if( column.type === ColumnTypes.COMPLEX){
        complexColumnNames.push(column.name);
        searchIntoComplexDataBy.push(column.searchInComplexBy)
      }
    }
    //console.log("complexColumnNames",complexColumnNames);
    //console.log("searchIntoComplexDataBy", searchIntoComplexDataBy);
    //cria um atributo no obj complextTypeFilter para cada complexColumnNames
    for(let i =0; i < complexColumnNames.length; i++){
      //atributos no obj Ex: this.complexTypeFilter.companies = []
      this.complexTypeFilter[complexColumnNames[i]] = [];
      for( let r of responseArray){
        // Ex: r.companies existe e a array nao é vazia?
        if(r[complexColumnNames[i]] && r[complexColumnNames[i]].length > 0 ){
          //console.log("Existe",r[complexColumnNames[i]])
          for(let data of r[complexColumnNames[i]]){
            // Ex: this.complexTypeFilter.companies = [ "Empresa Modelo",...]
            this.complexTypeFilter[complexColumnNames[i]].push({value:data.id,label:data[searchIntoComplexDataBy[i]]})
          }
        }
      }
      //retira os valores duplicados
      let check = new Set();
      this.complexTypeFilter[complexColumnNames[i]] = this.complexTypeFilter[complexColumnNames[i]].filter(
        //(el,index) => this.complexTypeFilter[complexColumnNames[i]].indexOf(el) === index
        obj => !check.has(obj.value) && check.add(obj.value)
      )
    }
    //console.log("complextTypeFilter",this.complexTypeFilter);
  }

  returnArray(f){
    if(this.complexTypeFilter[f.collumn.name]){
      return this.complexTypeFilter[f.collumn.name]
    }
    return []
  }
  
 }
 
 export enum ActionDataList {
   NEW, SELECT, ADICTION
 }
 